import * as React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { ArrowDropDownCircle } from "@material-ui/icons";

// components
import { LogoHorizontal } from "@components/logo";

// internals
import * as s from "./Nav.styles";

export interface IProps extends WithStyles<typeof s.styles> {
  onClickCollapse?: () => void;
}

export interface IState {
  isMouseHovered: boolean;
}

class NavComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isMouseHovered: false,
    };
  }

  ///////////////
  // Listeners //
  ///////////////

  private onClickCollapse = () => {
    if (this.props.onClickCollapse) {
      this.props.onClickCollapse();
    }
  };

  private onMouseEnter = () => {
    this.setState({
      isMouseHovered: true,
    });
  };

  private onMouseLeave = () => {
    this.setState({
      isMouseHovered: false,
    });
  };

  ///////////////
  // Rendering //
  ///////////////

  public render() {
    const stubMenuItem = <div style={{ width: 48 }} />;

    return (
      <div style={s.container} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        <div style={s.gradientBar}></div>
        <div style={s.navContainer}>
          {stubMenuItem}
          <LogoHorizontal {...s.logo} />
          {this.state.isMouseHovered ? (
            <Tooltip title="Close">
              <IconButton style={s.navCollapseButton} onClick={this.onClickCollapse}>
                <ArrowDropDownCircle id="cwClose" className={this.props.classes.navCollapse} />
              </IconButton>
            </Tooltip>
          ) : (
            stubMenuItem
          )}
        </div>
      </div>
    );
  }
}

export const Nav = withStyles(s.styles)(NavComponent);
